<template>
  <form @submit.stop.prevent="changeDate">
    <div class="my-5">
      <label>Current Delivery Date</label>
      <h4><strong>{{current_date}}</strong></h4>
    </div>
    <div class="my-5">
      <label>New Delivery Date</label>
      <DatePicker v-model="delivery_date" :disabled-dates="disabledDates" format="yyyy-MM-dd"></DatePicker>
      <p
          v-for="error of v$.delivery_date.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in ordersErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="sm" class="py-2" disabled v-if="ordersLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-2 text-white" type="submit" v-else>
        Change Date
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import moment from "moment";
import {mapGetters} from "vuex";
import DatePicker from '@sum.cumo/vue-datepicker'
import '@sum.cumo/vue-datepicker/dist/Datepicker.css'

export default {
name: "change-delivery-date-modal-component",
  setup () {
    return { v$: useVuelidate() }
  },
  props: {
    current_date: { type: String },
    today: { type: String }
  },
  components: {DatePicker},
  data(){
    return{
      delivery_date: '',
      disabledDates: {
        to: new Date(this.today)
      },
    }
  },
  validations () {
    return {
      delivery_date: {required},
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading',
      ordersErrors: 'orders/ordersErrors'
    }),
  },
  methods: {
    async changeDate(){
      this.v$.$touch();
      this.$emit('changeDate', moment(this.delivery_date).format('YYYY-MM-DD'))
    }
  }
}
</script>

<style scoped>

</style>
